"use strict";
/* globals module */
/**
 * @module meteringCategoryRoute  * @description Baasic Metering Category Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Category Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var _1 = require("./");
var contracts_1 = require("../../core/contracts");
var MeteringCategoryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringCategoryRoute, _super);
    function MeteringCategoryRoute(appOptions, meteringCategoryBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.meteringCategoryBatchRoute = meteringCategoryBatchRoute;
        _this.findRoute = 'metering/categories/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'metering/categories/{id}/{?embed,fields}';
        _this.createRoute = 'metering/categories';
        _this.updateRoute = 'metering/categories/{id}';
        _this.deleteRoute = 'metering/categories/{id}';
        return _this;
    }
    Object.defineProperty(MeteringCategoryRoute.prototype, "batch", {
        get: function () {
            return this.meteringCategoryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find metering category route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify metering resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain metering subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the metering property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example meteringCategoryRoute.find({searchQuery: '<search-phrase>'});
     **/
    MeteringCategoryRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id MeteringCategory id which uniquely identifies MeteringCategory resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example meteringCategoryRoute.get(id);
     **/
    MeteringCategoryRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create metering category route; this URI template does not expose any additional options.
     * @method
     * @example meteringCategoryRoute.create();
     **/
    MeteringCategoryRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update metering category route; this URI template does not expose any additional options.
     * @method
     * @param data An meteringCategory object used to update specified MeteringCategory resource.
     * @example meteringCategoryRoute.update();
     **/
    MeteringCategoryRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete metering category route; this URI template does not expose any additional options.
     * @method
     * @param data An meteringCategory object used to delete specified MeteringCategory resource.
     * @example meteringCategoryRoute.delete();
     **/
    MeteringCategoryRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    MeteringCategoryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MeteringCategoryBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MeteringCategoryBatchRoute !== "undefined" && _1.MeteringCategoryBatchRoute) === "function" ? _b : Object])
    ], MeteringCategoryRoute);
    return MeteringCategoryRoute;
}(common_1.BaseRoute));
exports.MeteringCategoryRoute = MeteringCategoryRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
